/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { type FC, type ReactNode } from "react";

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  minHeight?: number;
  className?: string;
}

/**
 * Generic empty state component for full-page empty states.
 * Used when there's no data to display.
 */
export const EmptyState: FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  minHeight = 400,
  className,
}) => {
  return (
    <div
      className={className}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: ${minHeight}px;
        gap: 0.5rem;
        padding: 2rem;
        text-align: center;
      `}
    >
      {icon && (
        <div
          css={css`
            margin-bottom: 0.5rem;
          `}
        >
          {icon}
        </div>
      )}
      <div
        css={css`
          font-weight: 500;
          color: #92400e;
        `}
      >
        {title}
      </div>
      {description && (
        <div
          css={css`
            font-size: 0.875rem;
            color: var(--color-gray-500);
            max-width: 400px;
          `}
        >
          {description}
        </div>
      )}
    </div>
  );
};
